<script setup lang="ts">
// ================================
// LAYOUT BLANK
// ================================
// Layout sans header ni sidebar : contenu plein page (ex. login, inscription).
// DEV-528 : h-full (au lieu de h-screen=100vh) pour s'aligner sur la hauteur
// disponible dans #app (= viewport moins safe-area paddings du body). h-screen
// ignorait ces paddings et faisait scroller la window en plus de main → rubber-band
// iOS qui claquait au relâchement (page d'invitation consentement inaccessible mobile).
</script>

<template>
    <div class="flex h-full min-h-0 flex-col min-w-0">
        <main class="min-h-0 min-w-0 flex-1 overflow-y-auto">
            <RouterView />
        </main>
    </div>
</template>
